<template>
  <div class=" font-inter">
    <main class="w-full">
      <CreateLearningGoalComponent />
    </main>
  </div>
</template>

<script>
import CreateLearningGoalComponent from "@/components/learning-goals/CreateLearningGoalComponent.vue";

export default {
  name: "CreateLearningGoal",
  components: {
    CreateLearningGoalComponent,
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped></style>
